<template>
  <div class="card card-top-line">
    <!-- Header -->
    <div class="header d-flex justify-content-between align-items-center">
      <h2>MOMO Accounts</h2>
    </div>
    <div class="body">
      <div class="chart-top-action d-lg-flex justify-content-between py-3">
        <div class="mr-0 mr-md-3 action-top-search">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search MOMO Account"
              aria-label="Search"
              v-model="search_keywords"
              aria-describedby="search-transactions"
              v-on:keyup.enter="getmomoAccounts"
            />
            <div class="input-group-append" @click="getmomoAccounts()">
              <span class="input-group-text" id="search-mail">
                <i class="icon-magnifier"></i>
              </span>
            </div>
          </div>
        </div>
        <!-- Table Pagination -->
        <div class="d-flex mt-auto table-pagination">
          <div class="number-page">
            <b-pagination
              class="pagination-small"
              v-model="currentPage"
              :total-rows="totalRows"
              first-text="First"
              last-text="Last"
              :per-page="perPage"
              align="right"
            ></b-pagination>
          </div>
        </div>
      </div>
      <b-table
        responsive
        outlined
        table-class="mb-0 table-custom"
        head-variant="light"
        :items="momoaccounts"
        :fields="momoaccountfields"
        :emptyText="'No data found.'"
        show-empty
        striped
      >
        <template #cell(momo_number)="data">
          <a href="javascript:void(0);" @click="editAccounts(data.item)">
            {{ data.value }}
          </a>
          <i
            class="fa fa-copy"
            v-if="data.value != '-'"
            @click="copyText(data.value, 'MOMO Number')"
          ></i>
        </template>
        <template #cell(block_status)="data">
          {{ data.value }}
          <select
            class="btn btn-filter badge badge-primary btn-sm"
            v-model="data.value"
          >
            <option value="">Select Option</option>
            <option
              v-for="(option, index) in blockStatuses"
              :key="index"
              :value="option"
            >
              {{ option.value }}
            </option>
          </select>
        </template>
      </b-table>
      <!-- Table Pagination -->
      <div
        class="d-flex py-3 align-items-center justify-content-between table-pagination"
      >
        <div class="per-page">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="number-page">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            first-text="First"
            last-text="Last"
            :per-page="perPage"
            align="right"
          ></b-pagination>
        </div>
        <div class="go-page">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">Go To Page</span>
            </div>
            <input
              type="text"
              v-model="currentPageJump"
              class="form-control"
              value=""
              @keyup.enter="onEnter"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GET_MOMOACCOUNTS } from "../../../store/actions.type.js";
export default {
  name: "MOMOAccounts",
  components: {
    //
  },
  data() {
    return {
      search_keywords: "",
      momoaccounts: [],
      momoaccountfields: [
        { key: "momo_number", label: "Mobile Number", thClass: "th_sortfix" },
        { key: "network", label: "Network", thClass: "th_sortfix" },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      blockStatuses: [
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
        { value: "Approved" },
      ],
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: true,
    };
  },
  methods: {
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
    editAccounts(data) {
      let params = {};
      params.name = "MOMO Account";
      params.value = data.momo_number;
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
    async getmomoAccounts() {
      let page = "";
      let size = "";
      // let sortby = "";
      // let sort = "";
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        size = this.perPage;
      } else {
        size = 10;
      }
      // if (this.sortBy == "") {
      //     sortby = "branchname";
      // } else {
      //     sortby = this.sortBy;
      // }
      // if (this.sortDesc == false) {
      //     sort = "d"; //"DESC";
      // } else {
      //     sort = "a";//"ASC";
      // }

      this.currentPageJump = page;
      const tempitems = [];
      let tempparam = `?size=${size}&page=${page}`; //sort=${sort}&sortby=${sortby}&
      if (this.search_keywords) {
        tempparam = tempparam + `&search=${this.search_keywords.trimStart()}`;
      }
      await this.$store
        .dispatch(GET_MOMOACCOUNTS, tempparam)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            details.map((item) => {
              let accounts = {
                network: item.provider_name,
                momo_number: item.wallet_number,
              };
              tempitems.push(accounts);
            });
            this.totalRows = response.data.query.total;
          }
          this.momoaccounts = tempitems;
        });
    },
  },
  async mounted() {
    await this.getmomoAccounts();
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getmomoAccounts();
      },
    },
    perPage: {
      handler: function () {
        this.getmomoAccounts();
      },
    },
  },
};
</script>
